import React from 'react'

export const Home = () => {
    return (
        <div>
            Not found!
        </div>
    )
}